import { memoize } from "lodash-es";

import { IWithRouteMatchProps, IWithRoutePropsProps } from "@/infrastructure/Route";

export interface TimeReportDetailsMatchParams {
  timeReportGuid: string;
}

export interface TimeReportDetailsRouteParams {
  timeReportGuid: string;
}

export type TimeReportDetailsMatchProps = IWithRouteMatchProps<TimeReportDetailsMatchParams>;

export type TimeReportDetailsRouteProps = IWithRoutePropsProps<TimeReportDetailsRouteParams>;

const transformPropsBody = (props: TimeReportDetailsMatchProps) => {
  return { timeReportGuid: decodeURIComponent(props.match.params.timeReportGuid) };
};

const transformPropsResolver = (props: TimeReportDetailsRouteProps) => {
  return props.location.pathname + props.location.search;
};

export const transformRouteProps = memoize(transformPropsBody, transformPropsResolver);
